import { message } from "antd";
import axios from "axios";
import { errorActions } from "../helpers/auth_helper";
import { BulkDocsInfoResult, BulkStatusDocResult, BulkStatusDocsPayload } from "../interfaces/account.interface";

export const getBulkStatusDocsInfo = async (
  po_numbers: string[]
): Promise<BulkDocsInfoResult | undefined> => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/zoho/bulk-status-docs-info/`, {
        params: { po_numbers: po_numbers.join(",") },
      })
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error fetching doc info. Please try again.");
        return undefined;
      });
  } catch (e) {
    message.error("Error fetching doc info. Please try again.");
    return undefined;
  }
};

export const createBulkStatusDocs = async (
  payload: BulkStatusDocsPayload
): Promise<BulkStatusDocResult | undefined> => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/zoho/bulk-status-docs/`, payload)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error creating Zoho docs. Please try again.");
        return undefined;
      });
  } catch (e) {
    message.error("Error creating Zoho docs. Please try again.");
    return undefined;
  }
};
